import React from 'react';

import { Card, FormItem } from '../../../components';
import { TagSymbolMappingsList } from '../../TagSymbolMappingsList';
import type { AgentForm as AgentFormType } from '../../../utilities';
import { validateTagSymbolMappings } from '../utils/validateTagSymbolMappings';

export type TagSymbolMappingsSettingsProps = {
  disabled?: boolean;
};

export const TagSymbolMappingsSettings: React.FC<
  TagSymbolMappingsSettingsProps
> = ({ disabled }) => {
  return (
    <Card
      collapsable
      size="unset"
      title="Tag Symbol Mappings"
      name="agentpage.tagSymbolMappings"
      contentClassName="flex flex-col gap-y-md"
      subtitle="Configure symbol/tag replacements per pipeline category (skiptts, ttsOnly, lnk, red)"
      withOverflow={false}
    >
      <FormItem<AgentFormType>
        name="tag_symbol_mappings"
        label=""
        inline={false}
        validate={validateTagSymbolMappings}
        renderError={() => null}
      >
        <TagSymbolMappingsList disabled={disabled} />
      </FormItem>
    </Card>
  );
};
